<template>
  <div class="faults">
    <Breadcrumb :home="home" :model="items" />

    <div class="fault_list" v-if="!loading">
      <form class="form" @submit.prevent="saveFault()">
        <div class="admin item">
          <h2 class="admin item">
            <u>{{ form.admin }}</u>
          </h2>
        </div>
        <Dropdown
          v-model="form.techstatus"
          :options="techStatus"
          optionLabel="name"
          optionValue="code"
          placeholder="Select a Tech Status"
        />

        <div class="desc item">
          <InputText
            class="p-text-uppercase box p-m-3"
            type="text"
            v-model="form.desc"
            placeholder="Fault Description"
          />
        </div>
        <div>
          Status: <strong>{{ form.status }}</strong>
        </div>

        <div class="repairstatus item">
          <label
            >Repair Status:
            <b v-if="form.repairstatus">{{ form.repairstatus }} </b>
            <b v-else>Status Not Set By Mechanic</b></label
          >
        </div>
        <br />

        <div class="user item">
          <label
            >Operator:
            <b v-if="form.user"
              >{{ form.user.rank }} {{ form.user.lastname }},
              {{ form.user.firstname }}
            </b></label>
        </div>

        <div class="created item" v-if="form.created">
          <label>
            Date Reported <b>{{ formatDate(form.created) }}</b>
          </label>
        </div>
        <br />
        <div class="mechanic item">
          <Dropdown
            v-model="form.mechanic"
            :options="availableMechanics"
            dataKey="id"
            placeholder="Assign Mechanic"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                {{ slotProps.value.rank }}
                <b>{{ slotProps.value.lastname }}</b>
                {{ slotProps.value.firstname }}
              </div>
            </template>
            <template #option="slotProps">
              {{ slotProps.option.rank }}
              <b>{{ slotProps.option.lastname }}</b>
              {{ slotProps.option.firstname }}
            </template>
          </Dropdown>
        </div>



        <div class="selector">
          <div @click="confirmRemove()" class="delete p-shadow-8">Delete</div>
        </div>

        <Dialog
          header="Confirmation"
          :visible="confirmRemoveDialog"
          :style="{ width: '350px' }"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span><b>THIS CAN'T BE UNDONE!!!</b><br/>Are you sure you want to delete this fault?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              @click="confirmRemoveDialog = false"
              class="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              @click="deleteFault()"
              class="p-button-text"
              autofocus
            />
          </template>
        </Dialog>
        <div>
          <Button
            class="create_button p-m-1 p-shadow-8"
            label="Save Changes"
            type="submit"
          />

          <div 
            class="selector" v-if="form.status == 'Verified'">
          <div class="submit" @click="confirmSubmit()">Send to GCSS-A --></div>
        </div>
        <Dialog
          header="Confirmation"
          :visible="confirmSubmitDialog"
          :style="{ width: '350px' }"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span>You are submitting this fault to be created in GCSS-Army.<br/><br/>
            <b>Are you sure</b> you want to submit this fault to the Clerks?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              @click="confirmSubmitDialog = false"
              class="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              @click="submitFault()"
              class="p-button-text"
              autofocus
            />
          </template>
        </Dialog>


        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { fb_db, fs } from "../firebase";
import { format } from "date-fns";
import Breadcrumb from "primevue/breadcrumb";
// import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import uics from "@/assets/uic.js";

export default {
  name: "FaultEditMM",
  components: {
    Dropdown,
    Breadcrumb,
    Dialog,
  },
  data() {
    return {
      home: { label: "Faults List", to: "/newfaults" },
      items: [{ label: "Edit" }],
      availableMechanics: [],
      loading: true,
      confirmRemoveDialog: false,
      confirmSubmitDialog: false,
      removethisfault: null,
      completed: false,
      statusList: ["All", "Not Assigned", "Assigned", "Verified"],
      techStatus: [
        {
          name: "Diagonal - /",
          code: "/",
        },
        {
          name: "Deadlined - X",
          code: "X",
        },
        {
          name: "Safety - E",
          code: "E",
        },
        {
          name: "Unknown - U",
          code: "U",
        },
        {
          name: "No Fault Found",
          code: "none",
        },
      ],
      form: {
        admin: null,
        techstatus: null,
        desc: null,
        created: null,
        mechanic: null,
        status: null,
        user: null,
      },
    };
  },
  async mounted() {
    await this.getFault();
    await this.getAvailableMechanics();
    this.loading = false;
  },
  methods: {
    async getFault() {
      await fb_db
        .collection("faults")
        .doc(this.$route.params.id)
        .get()
        .then(async (doc) => {
          this.form = doc.data();
          this.form.id = doc.id;
          if (this.form.mechanic) {
            let mechanic = await this.form.mechanic.get();
            this.form.mechanic = mechanic.data();
          }
          let user = await this.form.user.get();
          this.form.user = user.data();
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },
    async getAvailableMechanics() {
      this.loading = true;
      await fb_db
        .collection("users")
        .where("puic", "==", this.userProfile.puic)
        .where("role", "in", ["Mechanic", "Maint. Manager"])
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((d) => {
            let item = d.data();
            item.id = d.id;
            items.push(item);
          });
          this.availableMechanics = items;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },

    saveFault() {
      if (this.form.mechanic) {
        this.form.status = "Assigned";
      }
      fb_db
        .collection("faults")
        .doc(this.faultId)
        .update({
          admin: this.form.admin,
          techstatus: this.form.techstatus,
          desc: this.form.desc,
          created: this.form.created,
          mechanic: this.form.mechanic ? fb_db.collection("users").doc(this.form.mechanic.id) : null,
          status: this.form.status
        })
        .then(() => {
          console.log("Fault successfully updated");
          this.form = {};
          this.$router.push("/newfaults");
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error!",
            detail: error,
            life: 3000,
          });
          console.error("error updating Fault: ", error);
        });
    },
    confirmSubmit() {
      console.log("confirm submit");
      this.confirmSubmitDialog = true;
    },
        confirmRemove() {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
    },
    deleteFault() {
      console.log("Remove fault");
      fb_db
        .collection("faults")
        .doc(this.form.id)
        .delete()
        .then(() => {
          this.confirmRemoveDialog = false;
          this.$router.push('/newfaults')
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:MM DD-MMM-YYYY");
    },
    submitFault() {
      if (this.form.mechanic) {
        this.form.status = "Needs Entered In GCSS";
        fb_db
          .collection("faults")
          .doc(this.faultId)
          .update({
            status: this.form.status
          })
          .then(() => {
            console.log("Fault successfully submitted");
            this.form = {};
            this.$router.push("/verifiedfaults");
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error!",
              detail: error,
              life: 3000,
            });
            console.error("error updating Fault: ", error);
          });
      } else {
        console.log('no mechanic assigned')
        // show toast
      }
    },
  },

  computed: {
    faultId() {
      return this.$route.params.id;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

label {
  color: black;
}
.faults {
  .fault_list {

    .selector {
      padding: 10px;
      display: flex;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .delete {
        background: #000000;
        // color: $white;
        cursor: pointer;
        margin: 0 auto;
      }

            .submit {
        background: #000000;
        // color: $white;
        cursor: pointer;
        margin: 0 auto;
      }

      .item {
        padding: 10px;
        text-align: left;
      }

      .admin {
      }

      .techstatus {
      }

      .desc {
      }

      .created {
      }

      .mechanic {
      }

      .user {
      }
    }
  }
  .editfault {
    form {
      overflow-y: scroll;
      height: calc(100vh - 180px);
    }
  }
}
</style>